import client from './client';

export const loginStart = (payload) => client.post('/api/auth/login', payload);

export const loginVerify = (payload) => client.post('/api/auth/login-verify', payload);

export const sendOtp = (payload) => client.post('/api/auth/send-otp', payload);

export const verifyOtp = (payload) => client.post('/api/auth/verify-otp', payload);

export const googleSession = (token) => client.get('/api/auth/google/session', { params: { token } });

export const googleStart = (payload) => client.post('/api/auth/google/start', payload);

export const googleCompleteSetup = (payload) => client.post('/api/auth/google/complete-setup', payload);

export const signup = (payload) => client.post('/api/auth/signup', payload);

export const submitMembershipApplication = (payload) => client.post('/api/auth/register', payload);

export const getUserProfile = (userId) => client.get(`/api/users/${userId}`);

export const updateUserProfile = (userId, payload) => client.put(`/api/users/${userId}`, payload);

export const forgotPassword = (payload) => client.post('/api/auth/forgot-password', payload);

export const resetPassword = (payload) => client.post('/api/auth/reset-password', payload);
